import { NewConnectionCmhState } from '@/store/new-connection-cmh/types';
import { RootState } from '@/store/types';
import { GetterTree } from 'vuex';

export const getters: GetterTree<NewConnectionCmhState, RootState> = {
  swdePrice(): number {
    return 1775;
  }
}
